import { inject, Injectable } from '@angular/core';

import { EMPTY, Observable, of, tap } from 'rxjs';

import { ModalService } from '@app/core/ui/components/modal';

import { BemobiCheckoutStrategyService } from './checkout-strategy.interface';
import { BemobiCheckoutModalComponent } from '../../components/bemobi-checkout-modal/bemobi-checkout-modal.component';
import {
  BemobiShopCheckoutResponse,
  isBemobiShopCheckoutResponse
} from '../../models/shop-checkout-response.model';

@Injectable()
export class BemobiCheckoutService implements BemobiCheckoutStrategyService {
  private readonly modal = inject(ModalService);

  execute(response: BemobiShopCheckoutResponse): Observable<void> {
    const sessionToken = response.sessionToken;

    if (!sessionToken) {
      return EMPTY;
    }

    return of(undefined).pipe(
      tap(() => {
        this.modal.open(BemobiCheckoutModalComponent, {
          options: {
            title: 'Finalizar pagamento',
            description:
              'Escolha a forma de pagamento e conclua sua compra com segurança.',
            disableBackdropClose: true,
            size: 'xl',
            closeButton: true,
            enableFullscreenOnMobile: true
          },
          data: {
            sessionToken
          }
        });
      })
    );
  }

  static isValidStrategy(
    response: BemobiShopCheckoutResponse
  ): response is BemobiShopCheckoutResponse {
    return isBemobiShopCheckoutResponse(response) && !!response.sessionToken;
  }
}
